import fromPairs from 'Helper/fromPairs';

/**
 * Transform array of objects to hashmap
 */
const arrayToHashmap = (arrayOfObjects, keys: string[], deep: boolean = false) => {
    return fromPairs(arrayOfObjects.map((item) => {
        const key = Object.keys(item).filter(x => keys.includes(x))[0];
        const values = Object.keys(item).filter(x => !keys.includes(x));
        const valuesContainingArray = values.filter(key => Array.isArray(item[key]));

        if (deep && valuesContainingArray.length > 0) {
            item[valuesContainingArray[0]] = arrayToHashmap(item[valuesContainingArray[0]], keys, deep);
        }

        // The object contains more than key and value
        if (values.length > 1) {
            const remainingProperties = Object.assign({}, ...values.map(valueKey => ({[valueKey]: item[valueKey]})));

            // Return key with remaining object values
            return [
                item[key],
                remainingProperties,
            ];
        }

        // Return key/value pair
        return [
            item[key],
            item[values[0]],
        ];
    }));
};

export default arrayToHashmap;
